(() => {
  const initialized = new WeakSet();
  const initialize = (scope = document) => {
    const sections = scope.matches?.('product-info') ? [scope] : scope.querySelectorAll('product-info');
    sections.forEach((section) => {
      if (initialized.has(section)) return;
      const button = section.querySelector('#ProductPopup-popup_groessentabelle');
      const opener = button?.closest('modal-opener');
      if (!opener) return;
      initialized.add(section);
      const originalParent = opener.parentElement;
      const originalNext = opener.nextSibling;
      const originalStyle = opener.getAttribute('style');
      let scheduled = false;
      const position = () => {
        scheduled = false;
        const groups = section.querySelectorAll('.gelato-customization-wrapper .g-selector-variants');
        const sizeGroup = Array.from(groups).find((group) => {
          const label = group.querySelector('.g-selector-label')?.textContent.trim().toLowerCase();
          return ['größe', 'grösse', 'size'].includes(label);
        });
        if (sizeGroup) {
          if (sizeGroup.nextElementSibling !== opener) {
            sizeGroup.after(opener);
            opener.style.display = 'block';
            opener.style.margin = '1.5rem 0';
          }
        } else if (opener.parentElement !== originalParent) {
          originalParent.insertBefore(opener, originalNext?.parentNode === originalParent ? originalNext : null);
          if (originalStyle === null) opener.removeAttribute('style');
          else opener.setAttribute('style', originalStyle);
        }
      };
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(position);
      });
      observer.observe(section, { childList: true, subtree: true });
      position();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
